import { template } from 'lodash'

interface QueryParams {
	[key: string]: string | number
}

export function parseQueryString(queryString: string): QueryParams {
	const pairs = queryString.split('&')
	return pairs.reduce((res: QueryParams, pair) => {
		const [key, value] = pair.split('=')
		res[key] = value
		return res
	}, {})
}

export function makeQueryString(paramsMap: QueryParams): string {
	const result: string[] = []

	for (const key in paramsMap) {
		const value = paramsMap[key]
		if (value != null) result.push(`${key}=${value}`)
		else result.push(`${key}`)
	}

	return result.join('&')
}

interface UrlObject {
	protocol?: string
	host?: string
	port?: string
	path?: string
	toString: () => string
}

// TODO: дополнить матчинг query и hash
const urlRegex = /(?:(\w+):\/\/)?([\d\w.-]*)(?::(\d*))?(\/.*)?/
export function parseUrl(url: string) {
	const [ , protocol, host, port, path ] = url.match(urlRegex)!
	return {
		protocol,
		host,
		port,
		path,
		toString() {
			return makeUrl(this)
		},
	}
}

export function makeUrl(urlObject: UrlObject) {
	const { protocol, host, port, path } = urlObject
	return `${protocol ? protocol + '://' : ''}${host || ''}${port || ''}${path || ''}`
}

const interpolate = /{([\s\S]+?)}/g
export function urlTemplate(string?: string) {
	return (data?: object) => {
		const dirtyUrl = template(string, { interpolate })(data)
		const parts = dirtyUrl.split('://')
		if (parts.length > 1) {
			const path = parts[1].replace(/\/+/g, '/')
			return `${parts[0]}://${path}`
		} else {
			return parts[0].replace(/\/+/g, '/')
		}
	}
}
